import { Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { ShiftTeam } from 'api/shiftTeams/shiftTeams.api'
import { getDisplayName } from 'helpers/global.helper/global.helper'
import React, { ReactElement } from 'react'
import StatusComponent from 'ui/components/StatusComponent/StatusComponent'

import styles from './ShiftInfoTeamList.module.less'

function TeamListWrapper({ shiftTeams }: { shiftTeams: ShiftTeam[] }): ReactElement {
  return (
    <>
      {shiftTeams.map((shiftTeam) => (
        <Grid
          key={shiftTeam.name}
          className={styles.ShiftInfoTeamList_TeamIcon}
          style={{ background: shiftTeam.color }}
        >
          <Typography className={styles.ShiftInfoTeamList_TeamIconText} variant="body1" display="inline">
            {getDisplayName(shiftTeam)}
          </Typography>
        </Grid>
      ))}
    </>
  )
}

type ShiftInfoTeamListProps = {
  shiftTeams: ShiftTeam[]
}
export default function ShiftInfoTeamList({ shiftTeams }: ShiftInfoTeamListProps): ReactElement {
  let status: 'pending' | 'success' | 'error'

  if (shiftTeams.length > 0) {
    status = 'success'
  } else {
    status = 'error'
  }
  return (
    <Stack direction="column" justifyContent="space-between" sx={{ width: '100%' }}>
      <StatusComponent
        data={{ shiftTeams }}
        status={status}
        Component={TeamListWrapper}
        ComponentProps={{ shiftTeams }}
      />
    </Stack>
  )
}
